export default __webpack_public_path__ + "media/bundles/App/layout/icon/svgs/file-video-1b1a3d026f8a8de3575999d46bfca5fa.svg";